import { Button, Modal } from "best-common-react";
import React from "react";
import { useTranslation } from "react-i18next";

type CountryCheckModalProps = {
  show: boolean;
  close: () => void;
};

const CountryCheckModal: React.FC<CountryCheckModalProps> = ({ show, close }) => {
  const { t } = useTranslation(["translation", "registration"]);

  return (
    <Modal show={show}>
      <Modal.Header>{t("translation:warning")}</Modal.Header>
      <Modal.Body>
        <div>
          {t("registration:countryCheckBeforeEmail")}{" "}
          <a href={`mailto:${t("registration:email")}`}>{t("registration:email")}</a>{" "}
          {t("registration:countryCheckAfterEmail")}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={close} variant="secondary">
          {t("translation:understand")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CountryCheckModal;
